import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserAuth } from "../../contexts/UserAuthContext";
import RouteAuthGate from "../common/RouteAuthGate";

const RequireUserAuth = ({ children }) => {
  const { user, userAuthChecked } = useUserAuth();
  const location = useLocation();

  if (!userAuthChecked) {
    return <RouteAuthGate label="Checking authentication" />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireUserAuth;
